type GAEventParams = Record<string, any>;

export const sendEvent = (event: string, params?: GAEventParams) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event,
    ...params,
  });
};
